import { environment } from '@environments/environment';

export const appStoreDevtoolsConfig = {
  maxAge: 25,
  logOnly: environment.production,
};
